import React from 'react'

const Forbidden = () => {
  return (
    <div className='flex flex-col items-center pt-64 p-5'>
      <h1 className='text-5xl text-blue-600 font-extrabold mb-2'>403</h1>
      <h1 className='text-3xl text-gray-900 font-extrabold'>You don't have access to this feature</h1>
    </div>
  )
}

export default Forbidden